function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import Button from '../Button';
const ARROW_LEFT = 'ArrowLeft';
const ARROW_RIGHT = 'ArrowRight';
const ARROW_UP = 'ArrowUp';
const ARROW_DOWN = 'ArrowDown';
const Switch = props => {
  var _tabPanelRef$current;
  const {
    switches,
    selected,
    onChange,
    tabPanelRef,
    idPrefix = 'switch'
  } = props;
  const ref = React.useRef(null);
  const optionKeys = switches.map(item => item.key);
  const currentTabIndex = optionKeys.findIndex(option => option === selected);
  const tabPanelId = tabPanelRef === null || tabPanelRef === void 0 || (_tabPanelRef$current = tabPanelRef.current) === null || _tabPanelRef$current === void 0 ? void 0 : _tabPanelRef$current.id;
  const toggleTab = event => {
    const {
      key
    } = event;
    if (currentTabIndex < 0 || ref.current == null) {
      return;
    }
    if (![ARROW_LEFT, ARROW_UP, ARROW_RIGHT, ARROW_DOWN].includes(key)) {
      return;
    }
    event.preventDefault();
    const direction = key === ARROW_LEFT || key === ARROW_UP ? 'previous' : 'next';
    const tabToSelectIndex = direction === 'next' ? currentTabIndex + 1 : currentTabIndex - 1;
    const tabToSelectKey = optionKeys[tabToSelectIndex];
    if (tabToSelectKey == null) {
      return;
    }
    const tabToSelect = ref.current.querySelector("[data-switch-option-key=\"".concat(tabToSelectKey, "\"]"));
    if (!tabToSelect) {
      return;
    }
    tabToSelect.focus();
    onChange(tabToSelectKey);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "Switch",
    role: "tablist",
    ref: ref
  }, switches.map(item => /*#__PURE__*/React.createElement(Button, _extends({}, item, {
    role: "tab",
    id: "".concat(idPrefix, "-").concat(item.key),
    "aria-selected": selected === item.key,
    tabIndex: selected === item.key ? 0 : -1,
    "aria-controls": tabPanelId,
    "data-switch-option-key": item.key,
    onKeyDown: toggleTab,
    onClick: e => {
      // Fire the onChange function if present.
      onChange(item.key);

      // Fire the onClick function if present.
      if (item.onClick) item.onClick(e);
    },
    type: selected === item.key ? 'primary' : 'secondary'
  }), item.children)));
};
export default Switch;